import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTrendingUp, FiAlertCircle } = FiIcons;

export default function Comparison() {
  return (
    <section id="compare" className="py-32 bg-[#faf9f6]">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-16 items-center">
          <div className="lg:w-1/3">
            <span className="text-red-600 font-bold uppercase tracking-[0.3em] text-xs mb-4 block">Education</span>
            <h2 className="text-4xl md:text-5xl font-black text-zinc-900 tracking-tighter mb-8 uppercase leading-none">Choose Your <br/> Alloy Base</h2>
            <p className="text-zinc-600 text-lg leading-relaxed mb-8">
              The metal defines the tool. High-carbon for precision seekers, stainless for high-volume efficiency.
            </p>
            <button className="btn-secondary w-full lg:w-auto uppercase tracking-widest text-xs">Read Full Guide</button>
          </div>

          <div className="lg:w-2/3 grid md:grid-cols-2 gap-8">
            <motion.div 
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              className="bg-white p-10 border-t-8 border-zinc-900 shadow-sm"
            >
              <h3 className="text-2xl font-black text-zinc-900 mb-6 uppercase tracking-tight">High Carbon</h3>
              <ul className="space-y-6">
                {[
                  { text: "Unrivaled edge retention and sharpness", icon: FiTrendingUp, color: "text-green-600" },
                  { text: "Develops protective patina with age", icon: FiTrendingUp, color: "text-green-600" },
                  { text: "Requires immediate hand-drying", icon: FiAlertCircle, color: "text-amber-500" }
                ].map((item, i) => (
                  <li key={i} className="flex gap-4">
                    <SafeIcon icon={item.icon} className={`${item.color} mt-1 shrink-0`} />
                    <span className="text-zinc-700 font-medium">{item.text}</span>
                  </li>
                ))}
              </ul>
            </motion.div>

            <motion.div 
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="bg-white p-10 border-t-8 border-zinc-300 shadow-sm"
            >
              <h3 className="text-2xl font-black text-zinc-900 mb-6 uppercase tracking-tight">Stainless Pro</h3>
              <ul className="space-y-6">
                {[
                  { text: "100% corrosion and stain resistant", icon: FiTrendingUp, color: "text-green-600" },
                  { text: "Tougher alloy, resists chipping", icon: FiTrendingUp, color: "text-green-600" },
                  { text: "More effort required for sharpening", icon: FiAlertCircle, color: "text-amber-500" }
                ].map((item, i) => (
                  <li key={i} className="flex gap-4">
                    <SafeIcon icon={item.icon} className={`${item.color} mt-1 shrink-0`} />
                    <span className="text-zinc-700 font-medium">{item.text}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}